import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

// src/cn.ts
function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export { cn };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map